// extracted by mini-css-extract-plugin
export default {"dialog":"VpABqQnnPMg-JJ3k2R2wCA==","tabSet":"_8LvYqgCsOOj34R6AMUxcfw==","switchesContainer":"IXdunPRCtb3lT0-6+udjBA=="};